import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/index';

const initialState = {
  siteId: '',
  fileStructure: {},
  fileFetchHasErrored: false,
  fileFetchIsLoading: false,
  isFileStructureShowing: true,
  openedFolder: 'config',
  openedFile: '',
  revision: {},
  revisionFetchHasErrored: false,
  revisionFetchIsLoading: false,
  sourceRevision: 0,
  diffContextDisplay: true,
  targetRevision: 0,
  xmlSourceFetchHasErrored: false,
  xmlSourceFetchIsLoading: false,
  xmlSourceFile: '',
  xmlTargetFetchHasErrored: false,
  xmlTargetFetchIsLoading: false,
  xmlTargetFile: '',
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export default store;
